export default function ProfileHeaderBar() {
  return (
    <div
      aria-label="Profile header"
      className="flex items-center px-6 py-3 border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900"
    >
      <h1 className="text-base font-semibold text-slate-900 dark:text-slate-100 m-0">
        My Profile
      </h1>
    </div>
  );
}
